

import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit
} from '@angular/core';

import { SideBarComponent } from "../../../../components/side-bar/side-bar.component";
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';
import { environment } from 'src/environments/environment';
import { ControllerService } from 'src/app/services/controller.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgFor, NgIf, NgClass } from '@angular/common';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { Subscription, interval } from 'rxjs';
import { DeviceImage } from 'src/app/models/common/device-image.model';
import { DEFAULT_DEVICE_IMAGE, DEVICE_IMAGE_MAP } from 'src/app/models/common/device-image-map';
import { RouteConstants } from 'src/app/constants/route-constants';
import { breadCrumbModel, Controller, Device, DeviceStatus } from 'src/app/models/common/device.model';
import { RebootControllerComponent } from "./reboot-controller/reboot-controller.component";
import { ControllerDetails } from 'src/app/models/common/controller-info.model';
import { CustomerCardComponent } from "./customer-card/customer-card.component";
import { StorageService } from 'src/app/services/storage.service';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common/common.service';
import { EmqxRecieveMessageModel } from 'src/app/services/common/emqx-receive-message.model';
import { ControllerStatus } from 'src/app/models/common/controller-status.models';
import {Location} from '@angular/common';
import { BreadcrumbModule } from 'primeng/breadcrumb';



@Component({
  selector: 'app-customer-dashboard',
  standalone: true,
  imports: [SideBarComponent, NgFor, NgIf, NgClass, RebootControllerComponent, CustomerCardComponent, NgbPaginationModule,BreadcrumbModule],
  templateUrl: './customer-dashboard.component.html',
  styleUrl: './customer-dashboard.component.css'
})
export class CustomerDashboardComponent implements OnInit {

  // UI and profile
  intervalSubscription: any;
  elem: any;
  isFullscreen: boolean = false;
  crypto = window.crypto || window.Crypto;
  array = new Uint32Array(1);
  admin = true
  abcd = true
  private timeoutId!: ReturnType<typeof setTimeout>;

  // Data holders
  controllerList: Controller[] = [];
  deviceList: Device[] = [];
  deviceUnderController: Device[] = [];
  deviceStatus: DeviceStatus[] = [];
  deviceStatusUnderController: DeviceStatus[] = [];
  showRebootPopup = false
  controllerDetails!:ControllerDetails
  showCustomerPopUp:boolean = false
  currentPage = 1;
  itemsPerPage = 10;
  autoSelectDone:boolean = false
  encryptedUserid:string = ""
  items :breadCrumbModel[]= []


  statusLoading:boolean = true

  selectedTabIndex: number = 0;
  readonly profile_image: string = '';
  readonly user_email: string = '';
  readonly fullname: string = '';
  readonly user_id: string = '';
  readonly timezone: string = '';
  readonly files_id: string = '';
  controller_uuid: string = "";
  installerUserId: string = "";
  _stream_called: boolean = false
    controller_status: ControllerStatus[] = [];


 
  // Flags
  streamCalled: boolean = false;

  constructor(
    private auth: AuthserviceService,
    private controller: ControllerService,
    private router: Router,
    private storage: StorageService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private _location: Location
  ) {}



  ngOnInit(): void {

    this.pageChanged(1);

    this.listenMqttMessages();
    this.setItemsPerPage(window.innerWidth);
    window.addEventListener('resize', this.onResize.bind(this));
    this.initializeComponent();
    this.get_controller_specific_status();

    
    this.timeoutId = setInterval(() => {
      this.get_controller_specific_status();
    }, 180000);
    
  }




onResize(event: Event): void {
  const width = (event.target as Window).innerWidth;
  this.setItemsPerPage(width);
}

setItemsPerPage(width: number): void {
  if (width < 640) {        // mobile
    this.itemsPerPage = 3;
  } else if (width < 768) { // tablets
    this.itemsPerPage = 6;
  } else {
    this.itemsPerPage = 10; // default for desktop
  }
}





  private async initializeComponent(): Promise<void> {



    this.getUserdetails()
    AppSessionStorageService.sideBarSelection = 1;
    this.dasboardSwitchOnRefresh();

    // Load controllers and devices
    await this.getControllerSpecificList();
    await this.getDeviceSpecificList();




    this.route.queryParams.subscribe(params => {
      const encryptedControllerUuid = params['controller'];

      this. encryptedUserid = params['user_id'];

      this.installerUserId = this.encryptedUserid ? this.auth.decryptParams(this.encryptedUserid):""

      this.controller_uuid = encryptedControllerUuid ? this.auth.decryptParams(encryptedControllerUuid):""
      
    }
  )

  this.setSelectedTabFromUuid()
  this.selectControllerByUuid(this.controller_uuid);
    


  }


  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize.bind(this));

    try {
    if (this.timeoutId){
      clearInterval(this.timeoutId);
    }
    } catch (_) {}
  }


  async getUserdetails():Promise<void>{
    await this.auth.fetchUserDetails()
    this.items = [
      {
        label: `Installer Dashboard`,
        escape: false,
        command: () => {
          this.router.navigate([
            RouteConstants.ADMIN_INSTALLER_ROUTES],
      
            { queryParams:{
                user_id:this.encryptedUserid ,
      
             replaceUrl: true }},
          );
        },
        styleClass: 'breadcrumb-back-btn'
      },
      {
        label: `${this.fullName}`,
        escape: false,
        styleClass: 'back-btn'
      }
    ];
  }



selectControllerByUuid(uuid: string): void {
  const index = this.controllerList.findIndex(controller => controller.controller_uuid === uuid);
  if (index !== -1) {
    const page = Math.floor(index / this.itemsPerPage) + 1;
    this.currentPage = page;
    this.autoSelectDone = true;
    this.pageChanged(page); // Will handle selection and filtering
  }
}




  get fullName():string{
    return (AppSessionStorageService.user?.firstname ?? '') + ' ' + (AppSessionStorageService.user?.lastname ?? '');
    }
    
  get userName():string{
    return AppSessionStorageService.user?.username ?? '';
  }

  get userId():string{
    return AppSessionStorageService.user?.user_id ?? '';
  }


  get profileImage(): string {
    return this.auth.getUserImage() ?? 'assets/default-image.svg';
  }


  getImagePath(deviceId: string): string {
    return DEVICE_IMAGE_MAP[deviceId] ?? DEFAULT_DEVICE_IMAGE;

  }

  onProfileTap(){
    this.showCustomerPopUp = true
  }

    setSelectedTabFromUuid(): void {
      const index = this.controllerList.findIndex(controller => controller.controller_uuid === this.controller_uuid);
      if (index !== -1) {
        this.selectTab(index);
      }
    }


  selectTab(index: number): void {
    this.statusLoading = true
    this.selectedTabIndex = 100;
    if (this.selectedTabIndex !== index) {
    this.selectedTabIndex = index;
    const selectedController = this.controllerList[index];
    
    this.filterControllerUuid(selectedController.controller_uuid);
    this.getDeviceSpecificStatus(selectedController.controller_uuid)
  }}

  filterControllerUuid(controller_uuid: string): void {

    this.deviceUnderController = this.deviceList.filter(
      (device: { controller_uuid: string }) =>
        device.controller_uuid === controller_uuid
    );

    this.getDeviceSpecificStatus(controller_uuid)
  }


  getDeviceStatus(device_id: string) {
    return this.deviceStatus.find(status => status.device_id === device_id);
  }

  async getControllerSpecificList(): Promise<void> {
    if (!this.streamCalled) {
      this.streamCalled = true;
      this.controllerList = await this.controller.get_controller_list();
    }
    this.streamCalled = false;
  }

  async getDeviceSpecificList(): Promise<void> {
    if (!this.streamCalled) {
      this.streamCalled = true;
      this.deviceList = await this.controller.get_device_list();
    }
    this.streamCalled = false;
  }


  async getDeviceSpecificStatus(controller_uuid:any): Promise<void> {
    if (!this.streamCalled) {
      this.streamCalled = true;
      this.deviceStatus = await this.controller.get_device_status(controller_uuid);
      this.statusLoading = false

    }
    this.streamCalled = false;
  }



  isDeviceOn(deviceId: string): boolean {
    const status = this.getDeviceStatus(deviceId)?.device_status;
    return status === 'turn_on';
  }




  get shouldRedirectToAdminDashboard(): boolean {
    return (
      !AppSessionStorageService.grantAccess &&
      AppSessionStorageService.auth?.role === 'administrator'
    );
  }

  dasboardSwitchOnRefresh(): void {
    if (this.shouldRedirectToAdminDashboard) {
      this.backToAdminDashboard();
    }
  }
  
  backToAdminDashboard(): void {
    AppSessionStorageService.grantAccess = null;
    this.router.navigate([RouteConstants.ADMIN_INSTALLER_ROUTES], { replaceUrl: true });
  }

  alarmHistory(deviceObject:Device){
    this.onDeviceClick(deviceObject.device_id,deviceObject.controller_uuid,true)
  }






  getDeviceImage(deviceId: string, controllerUuid:string): DeviceImage {
    const isOn = this.getDeviceStatus(deviceId)?.device_status === 'turn_on';
    this.statusLoading = false


    const isOnline = this.get_controller_status(controllerUuid);
    if (deviceId === "WaterMeter") {
    return {
    src: isOnline == 'online' ? "assets/img/device_on.svg" : "assets/img/device-offline-on.svg",
    alt: isOnline ? "watermeter on" : "watermeter offline"
    };
    }
    else if (this.get_controller_status(controllerUuid) === "online"){
    return {
      src: isOn ? 'assets/img/device_on.svg' : 'assets/img/device_off.svg',
      alt: isOn ? 'Schedule On' : 'Schedule Off'
    }} else{

    return {
      src: isOn ? 'assets/img/device-offline-on.svg' : 'assets/img/device_off.svg',
      alt: isOn ? 'Schedule On' : 'Schedule Off'

    }
  }}
  
  shouldShowScheduleIcon(deviceId: string): boolean {
    const scheduleStatus = this.getDeviceStatus(deviceId)?.schedule_status;
    return scheduleStatus === 'schedule_on';
  }
  reboot(controller_tag:string,controller_uuid:string){
    this.showRebootPopup = true
    this.controllerDetails = {"controller_tag":controller_tag,"controller_uuid":controller_uuid}

  }

  closeModal(){
    this.showRebootPopup = false
    this.showCustomerPopUp = false
  }
  



pageChanged(event: any) {
  this.currentPage = event;

  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  const visibleItems = this.controllerList.slice(startIndex, endIndex);
  let actualIndex:number;
  
  if (this.autoSelectDone){
  // Check if the controller_uuid is in the current page
  const localIndex = visibleItems.findIndex(item => item.controller_uuid === this.controller_uuid);

   actualIndex = localIndex !== -1 ? startIndex + localIndex : startIndex;
   this.autoSelectDone = false; // Reset flag
   }else {
    // On normal page change, always select the first item
    actualIndex = startIndex;
  }
  const selectedItem = this.controllerList[actualIndex];

  if (selectedItem) {
    this.selectedTabIndex = actualIndex;
    this.filterControllerUuid(selectedItem.controller_uuid);
    this.getDeviceSpecificStatus(selectedItem.controller_uuid);
  }
}







  get paginatedInfo() {
    try {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      if (this.controllerList) {
        return this.controllerList.slice(startIndex, endIndex);
      } else {
        return this.controllerList;
      }
    } catch (_) {
      return []
    }
  }


  private listenMqttMessages(): void {
    this.commonService.subscribeMqttMessages('DashboardComponent',(message) => {
      /// can't set this as .subscribe(this.onMqttMessageReceived) - It will act as closure and  this keyword acts as onMqttMessageReceived function on onMqttMessageReceived function
      this.onMqttMessageReceived(message);
    });
  }
 
  private onMqttMessageReceived(message: EmqxRecieveMessageModel) {
    if (message.payload) {
      if (message.payload.has('controller_status')) {
        this.onControllerStatusReceived(
          message.payload
        );
      }
    }
  }
 
  private onControllerStatusReceived(data: any): void {
    this.storage.saveToLocalStorage(
      data.get("controler_uuid"),
      data.get("controller_status")
    );
  }




  onDeviceClick(deviceId: string, controllerUuid: string,alarms?:boolean): void{
    const encryptedDeviceId = this.auth.encryptParams(deviceId);
    const encryptedControllerUuid = this.auth.encryptParams(controllerUuid);
    this.router.navigate([
      RouteConstants.DEVICE_CUSTOMER_ROUTES],

      { queryParams:{
          device: encryptedDeviceId,
          controller: encryptedControllerUuid,
          user_id:this.encryptedUserid,
          alarms:alarms,

       replaceUrl: true }},
    );

}

  get_controller_status(controller_uuid: string) {
    const status = this.storage.getFromLocalStorage(controller_uuid);
    if (status) {
      return status;
    } 
    return 'offline';
  }




  async get_controller_specific_status() {
    if (!this._stream_called) {
      this._stream_called = true;
      this.controller_status = await this.controller.get_controller_status(this.installerUserId) as ControllerStatus[];
      for (const record of this.controller_status) {
        this.storage.saveToLocalStorage(
          record.controller_uuid,
          record.controller_status
        );
      }
    }
    this._stream_called = false;
  }

}